import React, { memo } from 'react';
import { Modal } from 'antd';
import styles from './index.module.scss';

export type ConfirmModalOtherProps = {
  isInputError: boolean;
  themeName: string;
  checkThemeNameIsExist: () => boolean;
  updateNewThemeName: (name: string) => void;
  updateInputError: (flag: boolean) => void;
};

type ConfirmModalProps = {
  action: string;
  title: string;
  content: string;
  open: boolean;
  confirmModalOtherProps: ConfirmModalOtherProps;
  confirmCallback: () => void;
  setModalClose: () => void;
  checkThemeName?: () => boolean;
};

const ConfirmModal = ({
  action,
  title,
  content,
  open,
  confirmModalOtherProps: {
    isInputError,
    themeName,
    checkThemeNameIsExist,
    updateNewThemeName,
    updateInputError,
  },
  checkThemeName,
  confirmCallback,
  setModalClose,
}: ConfirmModalProps) => {
  const handleOnOk = () => {
    if (action === 'create' && checkThemeName && checkThemeName()) {
      confirmCallback();
      setModalClose();
    }
    if (action !== 'create') {
      confirmCallback();
      setModalClose();
    }
  };

  return (
    <Modal open={open} onOk={handleOnOk} onCancel={setModalClose}>
      <div>
        <div>
          <h3 className={styles.textColor}>{title}</h3>
        </div>
        <div>
          <h5 className={styles.textColor}>{content}</h5>
        </div>
        {action === 'create' ? (
          <div>
            <input
              type="text"
              className={isInputError ? styles.error : styles.input}
              placeholder="請輸入新主題名稱"
              onChange={async (event) => {
                if (action === 'create') {
                  const newName = event.target.value;
                  if (newName !== '') {
                    updateInputError(false);
                  }
                  updateNewThemeName(newName);
                }
              }}
              value={themeName}
            />
            {isInputError && checkThemeNameIsExist() === false ? (
              <p className={styles.errorText}>主題名稱不可為空白</p>
            ) : isInputError && checkThemeNameIsExist() ? (
              <p className={styles.errorText}>
                此主題名稱已存在，請使用其他名稱
              </p>
            ) : null}
          </div>
        ) : null}
      </div>
    </Modal>
  );
};

export default memo(ConfirmModal);
